import { AuthHistorySources } from "./enums/authHistorySources";
/**
 * Данные по значению элемента списка в декларации списка.
 */
export class AuthorizationsHistoryData {
  public Ip: string = "";

  public Time: string = "";

  public Source: AuthHistorySources = 0;

  public Success: boolean = false;

  public PlatformVersion: string = '';

  public PlatformName: string = '';

  /**
   * Конструктор с заполнением.
   * @param src данные с сервера.
   */
  constructor(src: any) {
    this.Ip = src.Ip ?? "";
    this.Time = src.Time ?? "";
    this.Source = (src.Source ?? 0) as AuthHistorySources;
    this.Success = src.Success ?? false;
    this.PlatformVersion = src.PlatformVersion ?? '';
    this.PlatformName =  src.PlatformName ?? '';
  }
}
